@if (visible$ | async) {
    <fieldset [formGroup]="datePerformedGroup">
        <ng-container *ngrxLet="datePerformed$; let datePerformed">
            @if (datePerformed.choices) {
                <div class="row">
                    <p class="col-12 col-sm-10" [innerHTML]="datePerformed.description"></p>
                    <span class="text-end col-sm-2 col-12 filter-text">{{ elementTypeLabel$ | async }}</span>
                </div>
                @if (datePerformed.choices && !datePerformed.function) {
                    <pace-forms-choices
                        [choices]="datePerformed.choices"
                        [formControl]="radioControl"
                    ></pace-forms-choices>
                }
            }
            <div class="row mb-3">
                <label class="text-start col-12 col-form-label" for="{{ datePerformed.id }}">{{
                    datePerformed.dateLabel
                }}</label>
                <div class="col-sm-auto col-9">
                    <div class="input-group">
                        <input
                            type="date"
                            class="form-control input-group-sm date-input"
                            [ngClass]="{ 'date-input-not-ok': datePerformed.choices?.choiceNegative?.selected }"
                            id="{{ datePerformed.id }}"
                            #dateInput
                            [formControl]="dateInputControl"
                        />
                        <div class="input-group-append">
                            <span class="input-group-text" (click)="dateInput.focus()"
                                ><fa-icon [icon]="faCalendar"></fa-icon
                            ></span>
                        </div>
                    </div>
                </div>
                <div class="col-3 text-sm-start text-end pe-0">
                    @if ((readOnly$ | async) === false && !dateInput.disabled) {
                        <button
                            class="btn btn-link"
                            (click)="setToday()"
                            translate="F4M_DATE_PERFORMED_SET_TODAY_BUTTON_LABEL"
                        ></button>
                    }
                </div>
                @if (showNotApplicableCheckbox$ | async) {
                    <div class="col-auto pt-sm-0 pt-4">
                        <div>
                            <div class="not-applicable">
                                <div class="checkbox-container">
                                    <input
                                        type="checkbox"
                                        class="form-control"
                                        id="{{ datePerformed.id }}-not-applicable"
                                        [formControl]="checkboxControl"
                                    />
                                    <label for="{{ datePerformed.id }}-not-applicable">
                                        @if (checkboxControl.value) {
                                            <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                                        }
                                    </label>
                                </div>
                                <label
                                    translate="F4M_NOT_APPLICABLE_LABEL"
                                    for="{{ datePerformed.id }}-not-applicable"
                                ></label>
                            </div>
                        </div>
                    </div>
                }
                @if (displayHistoryButton$ | async) {
                    <div class="col-auto pt-sm-0 pt-4 ms-auto d-flex align-items-center">
                        <pace-forms-history-button [uniqueId]="datePerformed.uniqueId"></pace-forms-history-button>
                    </div>
                }
            </div>
            @if (showRemarksField$ | async) {
                <div class="row mb-3">
                    <div class="col">
                        <pace-forms-input-text
                            [id]="datePerformed.remarksXmlId"
                            [label]="datePerformed.remarksLabel"
                            [formControl]="remarksControl"
                        ></pace-forms-input-text>
                    </div>
                </div>
            }
        </ng-container>
    </fieldset>
}
